import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Home from '@/pages/Home'
import Conditions from '@/pages/Conditions'
import Contact from '@/pages/Contact'
import Blog from '@/pages/Blog'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  routes: [
    {
      path: '/:lang',
      // create a container component
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'conditions',
          name: 'conditions',
          component: Conditions
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        },
        {
          path: 'blog',
          name: 'blog',
          component: Blog
        },
        {
          path: '*',
          redirect: '/:lang'
        }
      ]
    },
    {
      path: '/',
      redirect: '/fr'
    }
  ],
  mode: 'history',
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }

    if (savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js